import axios from "axios";
import { Storage } from '@ionic/storage'
import moment from "moment";
const storage = new Storage()

const state = {
    images: [
        [
            {view: 'Front', status: 'edit', image_type: 0},
            {view: 'Back', status: 'edit', image_type: 0},
            {view: 'Side', status: 'edit', image_type: 0}
        ],
        [
            {view: 'Front', status: 'edit', image_type: 1},
            {view: 'Back', status: 'edit', image_type: 1},
            {view: 'Side', status: 'edit', image_type: 1}
        ]
    ],
    workout_data: null,
    evolt_data: null,
    targets: null,
    selectedChart: 'points',
    photoType: '1',
    pointsTilNow: 0,
    evolt_error: null
}
const mutations = {
    UPDATE_IMAGE (state, data) {
        // state.images[0][1] = data
        if(!data) return

        var image = state.images[state.photoType].find(el => {
            return el.view === data.view
        })

        image.src = data.src
        image.id = data.id
        // state.images[0][1].id = data.id
    },
    async UPDATE_WORKOUT_DATA (state, data) {
        if(!data) {
            await storage.get('workout_data').then((val) => {
                data = val
            })
        }
        storage.set('workout_data', data)
        state.workout_data = data
    },
    async UPDATE_EVOLT_DATA (state, data) {
        if(!data) {
            await storage.get('evolt_data').then((val) => {
                data = val
            })
        }
        //if(data !== 'not found') {
        if(data && data.length < 1) data = 'not found'
        storage.set('evolt_data', data)
        //} else {
        //    storage.remove('evolt_data')
        //}
        state.evolt_data = data
    },
    async UPDATE_TARGETS (state, data) {
        if(!data) {
            await storage.get('targets').then((val) => {
                data = val
            })
        }
        storage.set('targets', data)
        state.targets = data
    },
    UPDATE_SELECTED_CHART (state, data) {
        state.selectedChart = data
    },
    UPDATE_PHOTO_TYPE (state, data) {
        state.photoType = data
    },
    UPDATE_POINTS_TIL_NOW (state, data) {
        state.PointsTilNow = data
    },
    SET_EVOLT_ERROR (state, data) {
        state.evolt_error = data
    }
}

const actions = {
    async uploadImage ({state, rootState}, image) {
        image.status = 'loading'

        await axios.post(rootState.settings.baseUrl + 'upload-image',
            {provider: 'members', image: image, image_type: state.photoType},
            {
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(async function () {
                image.status = 'success'
                setTimeout(() => image.status = 'edit', 2000)
            })
            .catch(function (error) {
                throw error.response
            })
    },
    async rotateImage ({rootState, commit}, image) {

        image.status = 'loading'

        await axios.post(rootState.settings.baseUrl + 'member/rotate-image',
            {provider: 'members', image_id: image.id},
            {
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(async function (response) {
                //console.log(response.data)
                commit('UPDATE_IMAGE', response.data)
                image.status = 'success'
            })
            .catch(function (error) {
                throw error.response
            })
    },
    async getImage ({state, rootState, commit}, view) {
        //console.log('getImage', view)

        var image = state.images[state.photoType].find(el => {
            return el.view === view
        })

        image.status = 'loading'

        await axios.post(rootState.settings.baseUrl + 'get-image',
            {view: view, photo_type: state.photoType},
            {
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(async function (response) {
                commit('UPDATE_IMAGE', response.data)
                image.status = 'success'
                setTimeout(() => image.status = 'edit', 2000)
            })
            .catch(function (error) {
                throw error.response
            })
    },
    async getEvoltData ({dispatch, rootState, commit}) {
        commit('SET_EVOLT_ERROR', null)
        await axios.post(rootState.settings.baseUrl + 'get-evolt-data',
            {},
            {
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
            )
            .then(async function (response) {
                dispatch('setEvoltData', response.data)
                setTimeout(() => dispatch('getEvoltData', true), rootState.settings.refresh_timeout)
            })
            .catch(async function (error) {
                await dispatch('setEvoltData', null)
                commit('SET_EVOLT_ERROR', error.response.data)
                throw error.response
            })
    },
    async getWorkoutData ({dispatch, rootState}) {

        await axios.post(rootState.settings.baseUrl + 'get-workout-data',
            {},
            {
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        )
            .then(async function (response) {
                dispatch('setWorkoutData', response.data)
                setTimeout(() => dispatch('getWorkoutData', true), rootState.settings.refresh_timeout)
            })
            .catch(function (error) {
                throw error.response
            })
    },
    setTargets ({commit}, value) {
        commit('UPDATE_TARGETS', value)
    },
    async updateTargets ({rootState}, data) {

        await axios.post(rootState.settings.baseUrl + 'update-targets',
            {challenge_id: rootState.challenge.challenge.id, targets: data},
            {
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(async function () {
                //console.log('targets', response)
            })
            .catch(function (error) {
                throw error.response
            })
    },
    setWorkoutData ({commit}, data) {

        commit('UPDATE_WORKOUT_DATA', data)

        /*
        var start = moment(rootState.challenge.challenge.start_date, 'DD/MM/YYYY')

        var weeks = rootGetters['challenge/weeks']
        if(!weeks || weeks < 0) weeks = 8

        var workout_data = new Array(weeks)

        if (data.hasOwnProperty('hrInfo')) workout_data[0] = {total: 0, workouts: []}

        if (data && data.hrInfo) {

            data.hrInfo.forEach(record => {

                var end = moment(record.end)
                var day = end.diff(start, 'days')
                var week = Math.floor(day/7)
                if(!workout_data[week] || workout_data[week].length < 0) workout_data[week] = {total: 0, workouts: []}

                for(var i=2; i <= 5; i++) {
                    workout_data[week].total += record['zone' + i + 'MEPs']
                }

                workout_data[week].workouts.push(workout_data[week].total)

            })
        }
        commit('UPDATE_WORKOUT_DATA', workout_data)
        */
    },
    setEvoltData ({commit}, data) {

        if(!data || data.length < 1) {
            data = [{
                body_fat_percentage: 0,
                body_fat_result: 0,
                lean_body_mass_result: 0,
                skeletal_muscle_mass_result: 0,
                visceral_fat_level: 0,
                weight_result: 0
            }]
        }

        console.log('evolt data', data)

        commit('UPDATE_EVOLT_DATA', data)
    },
    setChartType ({commit}, data) {
        commit('UPDATE_SELECTED_CHART', data)
    },
    setPhotoType ({commit}, data) {
        commit('UPDATE_PHOTO_TYPE', data)
    }
}

const getters = {
    dataSet (state) {
        switch(state.selectedChart) {
            case 'points':
                return [
                    {x: 0.5, y: 200},
                    {x: 2.5, y: 500},
                    {x: 2.7, y: 600},
                    {x: 3, y: 700},
                    {x: 4, y: 700},
                    {x: 5, y: 800},
                    {x: 6, y: 900},
                    {x: 6.5, y: 1200, count: 'test'},
                    {x: 7},
                    {x: 8},
                    {x: 9},
                    {x: 10},
                    {x: 11},
                    {x: 12},
                ]
            case 'weight':
                return [
                    {x: 0},
                    {x: 1, y: 5},
                    {x: 2, y: 15},
                    {x: 12}
                ]
        }

    },
    evoltChartData (state, getters, rootState) {
        if(!state.evolt_data) return []
        var data = []
        var start = moment(rootState.challenge.challenge.start_date, 'DD/MM/YYYY')
        if (state.evolt_data.length > 0 && state.evolt_data != 'not found') {
            state.evolt_data.forEach(evolt => {
                var val = 0
                switch(state.selectedChart) {
                    case 'weight':
                        val = evolt.weight_result
                        break
                    case 'lbm':
                        val = evolt.lean_body_mass_result
                        break
                    case 'body_fat':
                        val = evolt.body_fat_percentage
                        break
                    case 'vfl':
                        val = evolt.visceral_fat_level
                        break
                }
                //console.log('evolt', evolt)
                var end = moment(evolt.date_time)
                var hour = end.diff(start, 'hours')
                data.push({
                    x: Math.max(.1, hour / (24 * 7)),
                    y: val,
                    date: moment(evolt.date_time).format('DD/MM/YYYY h:m:s')
                })
            })
        }
        return data
    },
    images (state) {
        return state.images[state.photoType]
    }
}

export default {
    namespaced: true, state, mutations, actions, getters
}
